import { Component, OnInit } from '@angular/core';
import { Subcliente } from '../subcliente.model';
import { BackendService } from '../../core/backend.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../shared-services/navigation.service';
import { ApiService } from '../../core/api.service';
import { Parametric } from '../../productos/parametric.model';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { SnackService } from '../../shared-services/snack.service';

@Component({
  selector: 'app-cliente-user-monto-max',
  templateUrl: './cliente-user-monto-max.component.html',
  styleUrls: ['./cliente-user-monto-max.component.scss']
})
export class ClienteUserMontoMaxComponent implements OnInit {

  cliente: any;
  subclientes: Subcliente[] = [];
  operacionSeleccionada = 'mensual';
  tipoLimites: Parametric[];

  isLoading = false;
  totalItems: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private snackService: SnackService,
    private navigationService: NavigationService,
    private apiService: ApiService,
    private dialogService: DialogService,
  ) { }

  async ngOnInit() {
    this.route.data.subscribe(data => {
      this.cliente = data.cliente;
    });
    await this.getSubclientes();
    await this.getTiposLimiteMontoCompra();
  }

  async getTiposLimiteMontoCompra() {
    this.tipoLimites = await this.apiService.get(Parametric, Parametric.path + 'tipos_limite_montos_compra/', null).toPromise();
  }

  async getSubclientes() {
    await this.backendService.get(Subcliente, Subcliente.path + 'all/' + this.cliente.id, null).toPromise().then(value => {
      this.subclientes = value as Subcliente[];
    });
  }

  back() {
    this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
  }

  confirmSave() {
    this.dialogService.confirm(
      '¿Está seguro que desea guardar los cambios?')
      .then(res => {
        if (res) {
          this.saveSubclientes(res);
        }
      });
  }

  async saveSubclientes(res) {

    if (res) {

      this.snackService.spinner(true);

      try {

        await await this.backendService.update(Subcliente.path + 'save-monto-max', this.subclientes);
        this.router.navigate(['/clientes/detalles/' + this.cliente.id]);
        this.snackService.success('Usuarios editados satisfactoriamente');

      } catch (ex) {
        if (ex[0]) {
          this.snackService.error(ex[0].details);
        } else if (ex.errors) {
          this.snackService.error(ex.errors[0].defaultMessage);
        } else {
          this.snackService.error(ex.message);
        }
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

  getChecked(event: any, index: number) {
    this.subclientes[index].idTipoMontoMax = event.value;
  }

  onPageChange(page: any) {
    // TODO: Paginar
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-user-monto-max/cliente-user-monto-max.component.ts